module.exports = __webpack_public_path__ + "img/map_1791458176600_31400.f6ffbfdf.jpg";